export const MAP_STYLES = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#202123',
      },
    ],
  },
  {
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#38414e',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#fafafa',
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      {
        lightness: 5,
      },
    ],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#d59563',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.medical',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#263c3f',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#6b9a76',
      },
    ],
  },
  {
    featureType: 'poi.school',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.sports_complex',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#38414e',
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#363c4d',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9ca5b3',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#2f3948',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#d59563',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#17263c',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#515c6d',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#17263c',
      },
    ],
  },
];

const initialCoordinates = {
  lat: 24.7936156935185,
  lng: 46.63233348465772,
};

const MAP_OPTIONS = {
  zoom: 14,
  maxZoom: 18,
  zoomControl: false,
  disableDefaultUI: true,
  scrollwheel: false,
  restriction: {
    latLngBounds: {
      north: 85.0,
      south: -85.0,
      west: -179.0,
      east: 179.0,
    },
    strictBounds: true,
  },
  styles: MAP_STYLES,
};

export const MAP_SETTINGS = {
  center: initialCoordinates,
  options: MAP_OPTIONS,
};

export const MARKER_SETTINGS = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'KSA Digital Disruption and Innovation Exchange',
  address: 'JW Marriott, Riyadh, Saudi Arabia',
  link: 'https://www.google.com/maps/place/JW+Marriott+Hotel+Riyadh/@24.7926417,46.6298015,17z/data=!3m1!4b1!4m9!3m8!1s0x3e2ee3763fca9449:0x44b29f775592e7c3!5m2!4m1!1i2!8m2!3d24.7926417!4d46.6323764!16s%2Fg%2F1pxq725g3?authuser=0&entry=ttu',
};
